<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Workflow assignment</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="formSubmit">
            <v-container grid-list-xl class="ma-0 pa-0" fluid>
              <v-layout>
                <v-flex xs12 class="subheading grey lighten-3">
                  Organization
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllCompanies" v-model="workflow.company_id" label="Company code"
                            item-value="id" :error-messages="errors.collect('company code')"
                            v-validate="'required'" data-vv-name="company code" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.company_code }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.company_code }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllDivisions" v-model="workflow.division_id" label="Division"
                            item-value="id" :error-messages="errors.collect('division')" item-text="initial"
                            v-validate="'required'" data-vv-name="division" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllPlants" v-model="workflow.plant_id" label="Plant"
                            item-value="id" :error-messages="errors.collect('plant')"
                            v-validate="'required'" data-vv-name="plant" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.plant }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.plant }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllDepartments" v-model="workflow.department_id" label="Department"
                            item-value="id" :error-messages="errors.collect('department')"
                            v-validate="'required'" data-vv-name="department" required>
                    <template slot="selection" slot-scope="data">
                       {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                       {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 class="subheading grey lighten-3">
                  Approval profile &amp; Requisitioner
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-select v-bind:items="getApprovalProfiles"
                            v-model="workflow.approval_profile_id" label="Approval profile"
                            item-value="id" :error-messages="errors.collect('approval profile')"
                            v-validate="'required'" data-vv-name="approval profile" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md3>
                   <v-text-field required label="Requisitioner" v-model="workflow.requisitioner" v-validate="'required|max:12'" :error-messages="errors.collect('requisitioner')" data-vv-name="requisitioner" :counter="12" persistent-hint hint="e.g. SALE-CRT"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 class="subheading grey lighten-3">
                  Max limit &amp; approvers assignment
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-select v-bind:items="getApprovalLimits" v-model="workflow.approval_limit_id" label="Max limit"
                            item-value="id" :error-messages="errors.collect('max limit')"
                            v-validate="'required'" data-vv-name="max limit" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.total_value_to === 0 ? 'Unlimited' : data.item.total_value_to | currency}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.total_value_to === 0 ? 'Unlimited' : data.item.total_value_to | currency}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_1"
                    label="Level 1"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 1')"
                    v-validate="'required'"
                    data-vv-name="level 1"
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_2"
                    label="Level 2"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 2')"
                    data-vv-name="level 2"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_3"
                    label="Level 3"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 3')"
                    data-vv-name="level 3"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_4"
                    label="Level 4"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 4')"
                    data-vv-name="level 4"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_5"
                    label="Level 5"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 5')"
                    data-vv-name="level 5"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_6"
                    label="Level 6"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 6')"
                    data-vv-name="level 6"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_7"
                    label="Level 7"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 7')"
                    data-vv-name="level 7"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select
                    v-bind:items="getApprovalUsers"
                    v-model="workflow.employee_id_level_8"
                    label="Level 8"
                    item-value="employee_id"
                    :error-messages="errors.collect('level 8')"
                    data-vv-name="level 8"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.employee_id }} - {{data.item.first_name }} {{data.item.last_name}}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="onFormWorkflowSubmit" dark color="accent" :loading="getLoading" :disable="getLoading">save
          </v-btn>
          <v-btn to="/workflow">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'new-workflow',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      workflow: {
        company_id: '',
        plant_id: '',
        division_id: '',
        department_id: '',
        approval_profile_id: '',
        approval_limit_id: '',
        employee_id_level_1: '',
        employee_id_level_2: '',
        employee_id_level_3: ''
      },
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  watch: {
    approval_profile_id: function (val, oldVal) {
      this.fetchApprovalLimits(val)
    }
  },
  computed: {
    ...mapGetters([
      'getLoading',
      'getResponse',
      'getAllCompanies',
      'getAllDivisions',
      'getAllDepartments',
      'getAllPlants',
      'getApprovalProfiles',
      'getApprovalLimits',
      'getApprovalUsers'
    ]),
    approval_profile_id () {
      return this.workflow.approval_profile_id
    }
  },
  methods: {
    ...mapActions([
      'fetchAllCompanies',
      'fetchAllDivisions',
      'fetchAllDepartments',
      'fetchAllPlants',
      'fetchAllApprovalProfiles',
      'fetchApprovalLimits',
      'fetchApprovalUsers',
      'addWorkflow'
    ]),

    onFormWorkflowSubmit () {
      this.$validator.validateAll().then(result => {
        this.addWorkflow(this.workflow).then(() => {
          let response = this.getResponse
          this.snackbar = true
          this.text =
            response.status === 200
              ? 'Added successfully.'
              : response.data.message
          this.color = response.status === 200 ? 'success' : 'error'
        })
      })
    },

    setRequisitioner (e) {
      // let id = e.target
      console.log(e)
    }
  },
  mounted: function () {
    this.fetchAllCompanies()
    this.fetchAllDivisions()
    this.fetchAllDepartments()
    this.fetchAllPlants()
    this.fetchAllApprovalProfiles()
    this.fetchApprovalUsers()
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workflow/NewWorkflow.vue